export const VERIFICATION_SUCCESS = "VERIFICATION_SUCCESS";
export const VERIFICATION_REQUEST = "VERIFICATION_REQUEST";
export const VERIFICATION_ERROR = "VERIFICATION_ERROR";
export const VERIFICATION_METHOD = "VERIFICATION_METHOD";

export const APPLICANT_VERIFICATION_ADD_INCOME =
  "APPLICANT_VERIFICATION_ADD_INCOME";
export const APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION =
  "APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION";
export const APPLICANT_VERIFICATION_VERIFY_EMAIL =
  "APPLICANT_VERIFICATION_VERIFY_EMAIL";
export const APPLICANT_VERIFICATION_REQUEST = "APPLICANT_VERIFICATION_REQUEST";
export const APPLICANT_VERIFICATION_SUCCESS = "APPLICANT_VERIFICATION_SUCCESS";
export const APPLICANT_VERIFICATION_FAILURE = "APPLICANT_VERIFICATION_FAILURE";
